import options from './org-structure-labels.component';

export default {
    selector: 'dtOrgStructureLabels',
    options
};
